import { Outlet, Navigate, useLocation } from "react-router-dom";

export default function AdmGate({ login = "/adm/login" }) {
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("adm_token") : null;
  const loc = useLocation();

  // 로그인 페이지는 토큰 없어도 접근 가능
  if (loc.pathname === "/adm/login") {
    // 토큰 있으면 어드민 홈으로 리다이렉트 (원하면 유지)
    return token ? <Navigate to="/adm/branch" replace /> : <Outlet />;
  }

  // 나머지 /adm/* 는 토큰 필수
  return token ? <Outlet /> : <Navigate to={login} replace />;
}